import { useId } from 'react';
import { Textarea } from '@/components/ui/textarea';

/** asset-service's limit on a share email's note. */
export const NOTE_MAX_LENGTH = 500;

/** The note shows its length from here on, so the cap never cuts a paste
 *  silently. */
const NOTE_COUNTER_FROM = 400;

interface NoteFieldProps {
  /** The bold part of the label; "(Optional)" follows it. */
  label: string;
  value: string;
  onChange: (note: string) => void;
  disabled: boolean;
}

/**
 * The optional plain-text note a share email carries, as the last section of
 * the bordered card that holds the recipient picker. Shared by Internal
 * Share (DV-3715) and Make Visible & Notify (DV-3563).
 */
const NoteField = ({ label, value, onChange, disabled }: NoteFieldProps) => {
  const noteId = useId();
  return (
    <div className="flex flex-col gap-1.5 border-t border-border px-3 pb-3 pt-2.5">
      <label htmlFor={noteId} className="text-sm">
        <span className="font-semibold">{label}</span>{' '}
        <span className="text-muted-foreground">(Optional)</span>
      </label>
      <Textarea
        id={noteId}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        maxLength={NOTE_MAX_LENGTH}
        rows={3}
        placeholder="Add a message to include in the email"
        className="min-h-[72px] resize-y"
      />
      {value.length >= NOTE_COUNTER_FROM && (
        <span className="self-end text-xs text-muted-foreground">
          {value.length}/{NOTE_MAX_LENGTH}
        </span>
      )}
    </div>
  );
};

export default NoteField;
